import React from 'react'
import { IProps, ContentDownload } from 'marketing-site/src/library/components/ContentDownload'
import { IContentDownload } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformImage } from '../elements/ContentfulImage'
import * as Utils from 'marketing-site/src/library/utils'

export const ContentfulCarousel = (data: IContentDownload) => (
  <EntryMarker entry={data}>
    <ContentDownload {...transformContentDownload(data)} />
  </EntryMarker>
)

export function transformContentDownload({ fields }: IContentDownload): IProps {
  return {
    ...fields,
    heading: fields.heading,
    image: transformImage(fields.image),
    stepOneListHeader: fields.stepOneListHeader && fields.stepOneListHeader,
    stepOneListItems: fields.stepOneListItems && fields.stepOneListItems,
    stepOneCTAText: fields.stepOneCtaText,
    stepTwoHeader: fields.stepTwoHeader && fields.stepTwoHeader,
    stepTwoMarketoFormID: fields.stepTwoMarketoForm.fields.marketoForm.id,
    stepThreeHeaderIcon: fields.stepThreeHeaderIcon && fields.stepThreeHeaderIcon.fields.file.url,
    stepThreeHeader: fields.stepThreeHeader && fields.stepThreeHeader,
    stepThreeCTAText: fields.stepThreeCtaText && fields.stepThreeCtaText,
    stepThreeDownloadURL: fields.stepThreeDownloadUrl && fields.stepThreeDownloadUrl,
    backgroundColor: Utils.getHexColorFromName(fields.backgroundColor),
  }
}
